import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TextScreenComponent from "../../TextScreenComponent/TextScreenComponent";

const useStyles = makeStyles(() => ({
    container: {
        padding: 10,
        maxHeight: 500,
        overflow: 'hidden'
    }
}));

const FeedContent = ({content}) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <TextScreenComponent
                properties={{
                    label: content
                }}
            />
        </div>
    )
};

export default FeedContent